// extracted by mini-css-extract-plugin
export default {"wrapper":"_163824c3","endingSoon":"_6124f682"};